export default {
    path: 'contract',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/contract/ContractList'),
    meta: {title:'充值记录'},
    children: [
        {
          path: 'create',
          component: () => import(/* webpackChunkName: "category-list" */ '@/pages/contract/CreateEdit'),
          meta: {title:'合同导入'},
        }
      ]
}